/*
  THE STORE IS INITIALIZED IN IT'S RESPECTIVE PACKAGES 
    1. WEB
    2. MOBILE
  TO USE THE STORE DISPATCHER IN COMMON LAYER FOR ADDING DATA TO REDUX STORE, WE
  NEED TO INJECT THE DISPATCHER FROM THE PACKAGES INTO COMMON LAYER.
*/

const EventDispatcher = () => {
  let _dispatcher: any = null;

  const set = (dispatcher: null | any) => {
    _dispatcher = dispatcher;
  }

  const dispatch = (event: any) => {
    if (_dispatcher) {
      _dispatcher(event)
    }
  }

  return { dispatch, set }
}

export default EventDispatcher();